var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',{ref:"wrapper",attrs:{"type-list":"invitations","item-source":_vm.fetchClanInvites,"replace-items":_vm.setAsInvited,"has-search":"","dummy-props":{
    headerText: _vm.$t('_web_account-list_dummy_clan_invations', ''),
    text: _vm.$t('_web_account-list_dummy_clan_invations_subheader', ''),
  }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var user = ref.user;
return _c('ListItemAccount',_vm._b({key:user.login,staticClass:"mb-4"},'ListItemAccount',{
      type: user.type,
      avatar: user.avatar,
      name: _vm.$filters.displayName(user),
      accountId: user.login,
      approved: user.approved,
      role: user.role,
      vanityId: user.vanityId || user.vanity_id,
    },false),[(_vm.account.canManage && !user.role)?_c('HeraFormBtn',{class:_vm.inviteClanBtnClass(user),attrs:{"slot":"action","loading":user.isLoading,"label":_vm.inviteClanText(user)},on:{"click":function($event){$event.stopPropagation();return _vm.inviteUser(user)}},slot:"action"}):_vm._e()],1)}}])})}
var staticRenderFns = []

export { render, staticRenderFns }